var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.invoice)?_c('div',{staticClass:"block-wrapper"},[_vm._v(" Входящий акт: "),_c('router-link',{attrs:{"to":_vm.url}},[_vm._v(_vm._s(_vm.text))])],1):_c('div',{style:({ display: 'flex', justifyContent: 'flex-end', padding: '10px' })},[_c('small',[_vm._v("Входящий акт не создан")])])
}
var staticRenderFns = []

export { render, staticRenderFns }